import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthService, AuthGuard } from '../../core';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente } from '../usuario/usuario-perfil';

/** Acessos permitidos à Prospecção Outbound */
export const acessosProspeccaoOutbound: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateProspeccaoOutbound implements CanActivateChild {

    constructor(private authGuard: AuthGuard,
                private authService: AuthService) { }

    canActivateChild(): boolean {
        // Somente se o usuário possuir acesso ao recurso de Prospecção Outbound
        const usuario = this.authService.getUsuario();
        if (usuario && !usuario.acessoProspeccaoOutbound) {
            return false;
        }

        return this.authGuard.canActivateAcesso(acessosProspeccaoOutbound);
    }
}
